/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component } from '@angular/core';
import { I18nService, PermissionService } from '@dm/core';
import { ActionType, infigo } from '@dm/live-material-infigo';

import { checkLicense } from '../../conditionalSearch/grammar.util';
import { DEFAULTRESOURCE } from '../../const';

interface ObjectConfig {
    title: string;
    icon: string;
    type: string;
}

@Component({
    selector: 'app-default-detail',
    templateUrl: './default-detail.component.html',
    styleUrls: ['./default-detail.component.scss'],
})
export class DefaultDetailComponent implements OnInit {
    searchObject: ObjectConfig[] = [];

    constructor(public i18n: I18nService, public permissionService: PermissionService) {
    }

    ngOnInit(): void {
        const check = this.permissionService.isLicenseExist.bind(this.permissionService);
        this.searchObject = checkLicense(check, DEFAULTRESOURCE[this.i18n.language]);
    }

    handleSelectedResource(selectedType: { title: string }): void {
        infigo.store.dispatch({
            type: ActionType.UserInput,
            value: selectedType.title + ' ',
        });
    }
}
